<td (dblclick)="setEditStateTrue('name')">
  <input
    id="competency-name"
    *ngIf="this.editedCell === 'name'"
    type="text"
    appPrefixFocusAndSelect
    (keydown.enter)="handleCompetencyUpdate()"
    (keydown.escape)="setEditStateFalse()"
    (focusout)="setEditStateFalse()"
    (change)="handleCompetencyUpdate()"
    [(ngModel)]="editedCompetency.name"
    (click)="inputClicked($event)"
  />
  <label
    class="text-overflow-dotted"
    [ngClass]="{ hidden: this.editedCell === 'name' }"
  >
    {{ competency.name }}
  </label>
</td>
<td>
  <select
    (change)="handleCompetencyUpdate()"
    [(ngModel)]="editedCompetency.competencyGroup.id"
  >
    <option *ngFor="let type of competencyGroups" [value]="type.id">
      {{ type.name }}
    </option>
  </select>
</td>
<td class="text-center">
  <fa-icon
    class="remove-icon fs-6"
    (click)="onDeleteCompetency(competency.id!)"
    [icon]="['fas', 'trash']"
  ></fa-icon>
</td>
